import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  NavContentBlueprint
} from '@backstage/plugin-app-react';
import { RootLayout } from './root.layout';

export const rootLayoutModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    NavContentBlueprint.make({
      params: { component: RootLayout },
    }),
  ],
});
